<template>
  <svg
    class="weui-icon-svg"
    width="40px"
    height="34px"
    viewBox="0 0 40 34"
    :style="{'font-size':pxToRem(size) }"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
    <title>形状结合</title>
    <desc>Created with Sketch.</desc>
    <g id="香港CDD" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="香港-CDD-2备份-18" transform="translate(-258.000000, -1046.000000)" :fill="fill">
        <g id="编组-3" transform="translate(191.000000, 1016.000000)">
          <g id="编组-2" transform="translate(67.000000, 22.000000)">
            <path
              d="M20,34 C15.581722,34 12,30.418278 12,26 C12,21.581722 15.581722,18 20,18 C24.418278,18 28,21.581722 28,26 C28,30.418278 24.418278,34 20,34 Z M8.36079545,13.3333333 L11.5901989,9.33333333 C12.1847156,8.59695367 13.2636203,8 14,8 L26,8 C26.7363797,8 27.8152844,8.59695367 28.4098011,9.33333333 L31.6392045,13.3333333 L38,13.3333333 C39.1045695,13.3333333 40,14.2287638 40,15.3333333 L40,39.3333333 C40,40.4379028 39.1045695,41.3333333 38,41.3333333 L2,41.3333333 C0.8954305,41.3333333 1.3527075e-16,40.4379028 0,39.3333333 L0,15.3333333 C-1.3527075e-16,14.2287638 0.8954305,13.3333333 2,13.3333333 L8.36079545,13.3333333 Z M20,36.6666667 C25.8910373,36.6666667 30.6666667,31.8910373 30.6666667,26 C30.6666667,20.1089627 25.8910373,15.3333333 20,15.3333333 C14.1089627,15.3333333 9.33333333,20.1089627 9.33333333,26 C9.33333333,31.8910373 14.1089627,36.6666667 20,36.6666667 Z"
              id="形状结合"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import mixins from '../mixins';
@Component
export default class FitCheckbox extends Mixins(mixins) {
  @Prop({ default: '#ffffff' }) fill;
  @Prop({ default: 36 }) size;
}
</script>
